module.exports = __webpack_public_path__ + "img/logo-top-shop.5dc80508.png";